// @flow
import { logout } from "./userActions";

export const handleResponse = (
  response: Response,
  responseType?: "IMAGE" | "JSON" | "TEXT" | "BUFFER" | "HTML" = "JSON"
): * => {
  if (response.status === 200) {
    if (responseType === "IMAGE") {
      return response.blob().then((blob: Blob): string => {
        let objectURL = URL.createObjectURL(blob);
        return objectURL;
      });
    } else if (responseType === "JSON") {
      return response.json().then((json: JSON): JSON => {
        return json;
      });
    } else if (responseType == "TEXT") {
      return response.body;
    } else if (responseType == "BUFFER") {
      return response.arrayBuffer().then((buf: Buffer): Buffer => {
        return buf;
      });
    } else if (responseType == "HTML") {
      return response.text();
    } else {
      return Promise.reject({
        api: "Wrong Response Type"
      });
    }
  } else if (response.status === 401) {
    // auto logout if 401 response returned from api
    //redirect to the logoff page
    logout((): * => (window.location.href = "/logoff"));
  } else if (response.status === 400 || response.status === 404) {
    return response.json().then((json: *): Promise<*> => {
      return Promise.reject(json.errors);
    });
  } else {
    return Promise.reject({
      api: response.status + " " + response.statusText
    });
  }
};

export function sleep(ms: number): Promise<*> {
  return new Promise(function (resolve: Function, reject: Function) {
    setTimeout(resolve, ms);
  });
}
